import type { Actions, IssueCreateIssueType, IssueCreateProject } from './types';

export const actions: Actions = {
	onChangeProject:
		(project: IssueCreateProject) =>
		({ setState }) =>
			setState({ project }),
	onChangeIssueType:
		(issueType: IssueCreateIssueType) =>
		({ setState }) =>
			setState({ issueType }),
	onChangeSummary:
		(summary: string) =>
		({ setState }) =>
			setState({ summary }),
	resetSummary:
		() =>
		({ setState }) =>
			setState({ summary: '' }),
};
